// extracted by mini-css-extract-plugin
export default {"toolbar":"Header_toolbar__BsjpX","innerBurger":"Header_innerBurger__1xZ84","box":"Header_box__5WnOn","burger":"Header_burger__BqrYh"};